<template>
  <gg-modal :is-active="opened" @close="closeModal">
    <template v-slot:toolbar>
      Change Home Path
    </template>
    <template v-slot:body>
      <v-form>
        <v-row>
          <v-col cols="12" class="pb-0">
            <p class="mb-0">Change account <strong>{{ account.user }}</strong> home path.</p>
          </v-col>
          <v-col cols="12">
            <autocomplete-dir v-model="dir" with-prefix></autocomplete-dir>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <gg-btn secondary @click="closeModal">
        Cancel
      </gg-btn>
      <gg-btn primary type="submit" :loading="loading" @click="saveHomedir">
        Change
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import AutocompleteDir from '@/components/Common/AutocompleteDir'

export default {
  name: 'ChangeHomePathModal',
  components: {
    AutocompleteDir,
  },
  model: {
    prop: 'opened',
    event: 'change',
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    account: {
      type: Object,
    }
  },
  data () {
    return {
      loading: false,
      dir: ''
    }
  },
  methods: {
    ...mapActions({
      setFtpHomeDir: 'ftp/setFtpHomeDir',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
    }),
    async saveHomedir () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      let homedir = '/'
      try {
        homedir = '/' + [...this.dir.split('/')].slice(3, this.dir.length).join('/')
      } catch (e) {
        console.warn(e)
      }
      const data = {
        user: this.account?.user,
        homedir,
        _username: this.$route.query.user,
      }
      try {
        await this.setFtpHomeDir(data)
        this.$emit('updated')
        this.reportSuccess('Home path successfully updated.')
        this.closeModal()
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
    },
    closeModal () {
      this.$emit('change', false)
    },
  },
  watch: {
    account (val) {
      this.dir = val?.dir
    }
  },
  mounted () {
    this.dir = this.account.dir
  },
}
</script>
